import { FeatureDetection } from './'

/**
* Destroys a given dom element
* @param {HTMLElement} $el - a reference to a dom element
*/
const destroyElement = $el => {
  if ($el == null || $el.parentNode == null) return
  $el.parentNode.removeChild($el)
}

/**
* Calls a given function on interaction with a given DOM Element (from a parent event trigger)
* @param {Object} e - The event data of the referencing DOM Element
* @param {String} selector - The selector to be queried
* @param {fn} - the callback function to run when the matched element is interacted with
*/
const delegateEvent = (e, selector, fn) => {
  // Only run function when all params exist
  if ((e && selector && typeof fn === 'function') == false) return

  const _matchesFn = FeatureDetection.browser.isIe11()
    ? 'msMatchesSelector'
    : 'matches';

  const $el = e.target

  if ($el[_matchesFn](selector)) {
    fn(e)
    e.preventDefault()
  }
}

const selectorMatches = ($el, selector) => {
    const _matchesFn = FeatureDetection.browser.isIe11()
        ? 'msMatchesSelector'
        : 'matches';
    return $el[_matchesFn](selector)
}

/**
 * Traverses up the DOM tree and returns the first parent element matching the given selector
 * @param {HTMLElement} $el - The element from which to begin traversing
 * @param {String} selector - The selector to match
 * @returns {HTMLElement} - The matched parent element
 */
const getParentNode = ($el, selector) => {
  if ($el.parentNode == null) return

  const $parent = $el.parentNode
  const _matchesFn = FeatureDetection.browser.isIe11()
    ? 'msMatchesSelector'
    : 'matches';

  return $parent[_matchesFn](selector)
    ? $parent
    : getParentNode($parent, selector)
}

const isValidSelector = string => /^[a-z\.#\[](?=\w)/i.test(string) 

const DomHelpers = {
  destroyElement,
  delegateEvent,
  getParentNode,
  selectorMatches,
  isValidSelector
}

export default DomHelpers



// WEBPACK FOOTER //
// ./js/utils/DomHelpers.js